import API from '~config/api';
import {
  ApiPromise,
  DataResponse,
  DataMessageResponse,
  ErrorResponse,
} from '~globals/types/api';

import {
  AdminIntegrationStockLocationExtended,
  AdminIntegrationStockLocationUpdateBody,
} from './types';

const ADMIN_INTEGRATION_STOCK_LOCATION_ENPOINTS = {
  getAdminIntegrationStockLocations: (companyIntegrationId: string): string =>
    `/api/v1/Route/StockLocation/${companyIntegrationId}`,
  updateAdminIntegrationStockLocations: '/api/v1/Route/StockLocation',
};

export const getAdminIntegrationStockLocations = (
  companyIntegrationId: string,
): ApiPromise<
  DataResponse<AdminIntegrationStockLocationExtended[]>,
  ErrorResponse
> =>
  API.get<DataResponse<AdminIntegrationStockLocationExtended[]>, ErrorResponse>(
    ADMIN_INTEGRATION_STOCK_LOCATION_ENPOINTS.getAdminIntegrationStockLocations(
      companyIntegrationId,
    ),
  );

export const updateAdminIntegrationStockLocations = (
  body: AdminIntegrationStockLocationUpdateBody,
): ApiPromise<DataMessageResponse, ErrorResponse> =>
  API.post<DataMessageResponse, ErrorResponse>(
    ADMIN_INTEGRATION_STOCK_LOCATION_ENPOINTS.updateAdminIntegrationStockLocations,
    body,
  );
